import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';

import { AppRouterModule } from '@app/router.module';
import { AppHelpersSearchModule } from 'app/components/helpers/search/search.module';

import { SettingsRulesRulesFormHelpersModule } from '../helpers/rules-form-helpers.module';

import { SettingsRulesRuleFormConditionsMainComponent } from './conditions-main/conditions-main.component';
import { SettingsRulesRuleFormConditionsItemComponent } from './condition-item/condition-item.component';
// import { SettingsRulesRulesFormHelpersSearchModule } from '../helpers/search/rules-form-helpers-search.module';
// import { SettingsRulesRuleFormActionsComponent } from './actions/actions.component';
// import { SettingsRulesRuleFormActionsItemComponent } from './actions-item/actions-item.component';
// import { SettingsRulesRuleFormActionsVariableItemComponent } from './actions-variable-item/actions-variable-item.component';

@NgModule({
    imports: [
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        HelpersModule,
        AppHelpersSearchModule,
        SettingsRulesRulesFormHelpersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsRulesRuleFormConditionsMainComponent,
        SettingsRulesRuleFormConditionsItemComponent,
        // SettingsRulesRuleFormActionsComponent,
        // SettingsRulesRuleFormActionsItemComponent,
        // SettingsRulesRuleFormActionsVariableItemComponent,
    ],
    exports: [
        SettingsRulesRuleFormConditionsMainComponent,
        SettingsRulesRuleFormConditionsItemComponent,
        // SettingsRulesRuleFormActionsComponent,
        // SettingsRulesRuleFormActionsItemComponent,
        // SettingsRulesRuleFormActionsVariableItemComponent,
    ],

})
export class SettingsRulesRulesFormConditionsModule { }
